<template>
    <div class="newsListPage">
        <div class="main">
            <div class="crumb">
                <router-link to="/pcpage/mainpage/home">
                    <span>{{ $t("message.home") }}</span>
                </router-link>
                <span class="icon">></span>
                <span class="current">{{ $t("message.worksshop") }}</span>
            </div>
            <div class="title" v-if="$i18n.locale=='cn'">
                <span>{{title|sliceTitle(3)}}</span>
                <span class="titleName">{{title|sliceTitle(4)}}</span>
            </div>
             <div class="title" v-if="$i18n.locale=='en'">
                <span>{{title}}</span>
                
            </div>
            <div class="list" v-if="topicData.info&&$i18n.locale=='cn'">
                <div class="topic">
                    <span>{{topicData.info.title|sliceTitle_1(3)}}</span>
                    <span class="titleName">{{topicData.info.title|sliceTitle_1(4)}}</span>
                </div>
                <div class="videoCon">
                    <video :src="'http://conference2019.hanban.org/upload/'+topicData.info.video" controls v-if="topicData.info.video"></video>
                </div>
                <div class="articleCon" v-if="topicData.info.description">
                    <div v-html="topicData.info.description" class="newsContent" :class="{ 'hideContent': isShow}">
                    </div>
                     <div class="loadMore" @click="showAll" v-if="isShow">
                        <img src="../img/loadmore.png" alt="">
                        <span>查看更多</span>
                    </div>
                </div>
                <div class="time" v-if="topicData.info.start_at">
                    <span class="leftCon">时间：</span> <span>{{topicData.info.start_at*1000|formatDate}}</span>
                </div>
                <div class="guestCon">
                    <span class="leftCon">主持人:</span> 
                    <div class="guestRight">
                        <span v-for="(newsItem, index) in topicData.info.presenter_list" :key="index" class="guestItem" @click="toDetail(newsItem.id)">
                            <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                            <div class="guestInfo">
                                <div>{{newsItem.realname}}</div>
                                <div class="guestTitle">{{newsItem.title}}</div>
                            </div>
                        </span>
                    </div>
                    
                </div>
                <div class="guestCon">
                    <span class="leftCon">发言人:</span> 
                    <div class="guestRight">
                        <span v-for="(newsItem, index) in topicData.info.guest_list" :key="index" class="guestItem"  @click="toDetail(newsItem.id)">
                            <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                            <div class="guestInfo">
                                <div>{{newsItem.realname}}</div>
                                <div class="guestTitle">{{newsItem.title}}</div>
                            </div>
                        </span>
                    </div>

                </div>
                
            </div>
            <div class="list" v-if="topicData.info&&$i18n.locale=='en'">
                <div class="topic">
                    <span>{{topicData.info.title_en|sliceTitle_1(3)}}</span>
                    <span class="titleName">{{topicData.info.title_en|sliceTitle_1(4)}}</span>
                </div>
                <div class="videoCon">
                    <video :src="topicData.info.video" controls v-if="topicData.info.video"></video>
                </div>
                <div class="articleCon" v-if="topicData.info.description">
                    <div v-html="topicData.info.description_en" class="newsContent" :class="{ 'hideContent': isShow}">
                    </div>
                     <div class="loadMore" @click="showAll" v-if="isShow">
                        <img src="../img/loadmore.png" alt="">
                        <span>查看更多</span>
                    </div>
                </div>
                <div class="time" v-if="topicData.info.start_at">
                    <span class="leftCon">Time：</span> <span>{{topicData.info.start_at*1000|formatDate}}</span>
                </div>
                <div class="guestCon">
                    <span class="leftCon">Presenter:</span> 
                    <div class="guestRight">
                        <span v-for="(newsItem, index) in topicData.info.presenter" :key="index" class="guestItem"  @click="toDetail(newsItem.id)">
                            <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                            <div class="guestInfo">
                                <div>{{newsItem.realname_en}}</div>
                                <div class="guestTitle">{{newsItem.title_en}}</div>
                            </div>
                        </span>
                    </div>
                    
                </div>
                <div class="guestCon">
                    <span class="leftCon">Speaker:</span> 
                    <div class="guestRight">
                        <span v-for="(newsItem, index) in topicData.info.guest_list" :key="index" class="guestItem"  @click="toDetail(newsItem.id)">
                            <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                            <div class="guestInfo">
                                <div>{{newsItem.realname_en}}</div>
                                <div class="guestTitle">{{newsItem.title_en}}</div>
                            </div>
                        </span>
                    </div>

                </div>
                
            </div>
        </div>
        <!-- <div class="bottom">
            版权所有 © 2019 孔子学院总部     京ICP 备 08002516号-5
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'topicdetail',
    data: function() {
        return {
            topic_id:null,
            title: '',
            topicData: {},
            isShow: false
        }
    },
    // 截取论坛
    filters: {
        sliceTitle (val,num) {
            if(num == 3){
                return val.slice(0,num)
            }else {
                return val.slice(num ,val.length)
            }
            
        },
        sliceTitle_1 (val,num) {
            if(num == 3){
                return val.slice(0,num)
            }else {
                return val.slice(num-1 ,val.length)
            }
            
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
    htmlDecode(text){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
        },
    getNewsList(id) {
      this.$utils
        .get("forum/api/getTopic", {
            lang: this.language,
            topic_id: id
        })
        .then(res => {
          this.topicData = res.data.data
          if(this.topicData.info.description){
              console.log(this.topicData.info.description.length)
              if(this.topicData.info.description.length>1500){
                  this.isShow = true
              }
              this.topicData.info.description = this.htmlDecode(this.topicData.info.description)
          }
        });
    },
    toDetail (id) {
        this.$router.push({
            path: '/pcpage/detailpage/guestdetail',
            query: {
                id: id
            }
        })
    },
    showAll () {
        this.isShow = false
    }
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          this.getNewsList()
      }
    },
  mounted() {
    this.topic_id = this.$route.query.topic_id
    this.title = this.$route.query.title
    this.getNewsList(this.topic_id)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsListPage {
    width: 62.5%;
    min-width: 1050px;
    height: 100%;
    margin: auto;
    background-color: #fff;
    .main {
        padding: 30px 50px 0;
        height: 100%;
        box-sizing: border-box;
        .crumb {
            font-size: 14px;
            a {
                color: #282828;
                text-decoration: none;
            }
            .icon {
                display: inline-block;
                margin: 0 6px;
            }
            .current {
                color: #1c58c1;
            }
        }
        .title {
            margin: 18px 0 18px;
            height: 50px;
            background-color: #e1eef3;
            color: #1c58c1;
            font-size: 28px;
            line-height: 50px;
            font-weight: bold;
            text-indent: 15px;
            .titleName {
                color: #000;
                margin-left: 8px;
            }
        }
        .list {
            height: calc(100% - 101px);
            min-height: 560px;
            border: 1px solid #e5e5e5;
            border-bottom: none;
            padding: 30px;
            .topic {
                font-size: 24px;
                color: #1c58c1;
                margin:0 2.5% 25px;

            }
            .titleName {
                margin-left: 8px;
                color: #000;
            }
            .newsContent {
                padding: 0 54px;
                /deep/ p {
                    font-size: 18px;
                    color: #282828;
                    line-height: 1.6;
                    margin: 5px auto;
                    strong {
                        font-weight: bold;
                    }
                }

                /deep/ video {
                    display: block;
                    width: 785px;
                    height: 523px;
                    margin: 0 auto;
                }
            }
            .hideContent {
                height: 400px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
            .loadMore {
                margin: 20px 48px;
                height: 50px;
                background-color: #e1eef3;
                text-align: center;
                color: #5e696d;
                font-size: 16px;
                line-height: 50px;
                cursor: pointer;
                img {
                    width: 10px;
                    height: 11px;
                    margin-right: 10px;
                }
            }
            .loadMore:hover {
                color: #f3bc65;
            }
            .videoCon {
                width: 95%;
                margin: auto;
                video {
                    width: 100%;
                }
            }
            .time {
                font-size: 16px;
                color: #282828;
                margin: 57px 2.5% 25px;
            }
            img {
                width: 75px;
                height: 75px;
                border-radius: 50%;
                margin-left: 30px;
            }
            .guestCon {
                margin: 40px 2.5% 0;
                .leftCon {
                    width: 84px;
                    display: inline-block;
                    text-align: right;
                }
                span {
                    vertical-align: top;
                }
                .guestRight {
                    display: inline-block;
                    margin-left: 30px;
                    width: calc(100% - 114px);
                }
                .guestItem {
                    display: inline-block;
                    margin-right: 70px;
                    margin-bottom: 40px;
                    cursor: pointer;
                    .guestInfo {
                        display: inline-block;
                        width: 220px;
                        height: 53px;
                        margin-left: 15px;
                        vertical-align: top;
                        word-break: break-all;
                        div:first-child {
                            font-size: 18px;
                            color: #282828;
                            margin-bottom: 10px;
                            font-weight: bold;
                        }
                        div:last-child {
                            color: #282828;
                            font-size: 16px;
                        }
                    }
                }
            }

        }
    }
}
    .bottom {
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        opacity: 0.5;
    } 
</style>
